import { AchievementDefinition } from '../types/achievements';

export const achievementDefinitions: AchievementDefinition[] = [
  // GAMEPLAY
  {
    id: 'first_win',
    name: 'First Victory',
    description: 'Complete a game without running out of hearts',
    icon: '🏆',
    category: 'GAMEPLAY',
    rarity: 'COMMON',
  },
  {
    id: 'perfect_game',
    name: 'Perfect Game',
    description: 'Answer every question correctly in a single game',
    icon: '💎',
    category: 'GAMEPLAY',
    rarity: 'LEGENDARY',
  },
  {
    id: 'comeback_king',
    name: 'Comeback King',
    description: 'Complete a game with only 1 heart remaining',
    icon: '👑',
    category: 'GAMEPLAY',
    rarity: 'EPIC',
  },
  {
    id: 'full_hearts',
    name: 'Iron Heart',
    description: 'Finish a game with all 5 hearts',
    icon: '🛡️',
    category: 'GAMEPLAY',
    rarity: 'RARE',
  },

  // STREAK
  {
    id: 'streak_3',
    name: 'On a Roll',
    description: 'Get a streak of 3 correct answers',
    icon: '🔥',
    category: 'STREAK',
    rarity: 'COMMON',
  },
  {
    id: 'streak_5',
    name: 'Hot Streak',
    description: 'Get a streak of 5 correct answers',
    icon: '⚡',
    category: 'STREAK',
    rarity: 'RARE',
  },
  {
    id: 'streak_10',
    name: 'Streak Master',
    description: 'Get a streak of 10+ correct answers',
    icon: '🌟',
    category: 'STREAK',
    rarity: 'EPIC',
  },
  {
    id: 'streak_15',
    name: 'Unstoppable',
    description: 'Get a streak of 15+ correct answers',
    icon: '💫',
    category: 'STREAK',
    rarity: 'LEGENDARY',
  },

  // SPEED
  {
    id: 'speed_demon',
    name: 'Speed Demon',
    description: 'Average answer time under 2 seconds in a game',
    icon: '⏱️',
    category: 'SPEED',
    rarity: 'EPIC',
  },
  {
    id: 'lightning_answer',
    name: 'Lightning Reflexes',
    description: 'Answer a question in under 1 second',
    icon: '⚡',
    category: 'SPEED',
    rarity: 'RARE',
  },
  {
    id: 'century_club',
    name: 'Century Club',
    description: 'Score 100+ points on a single answer',
    icon: '💯',
    category: 'SPEED',
    rarity: 'COMMON',
  },

  // CHALLENGE
  {
    id: 'challenge_conqueror',
    name: 'Challenge Conqueror',
    description: 'Answer all HARD questions correctly in a game',
    icon: '🏅',
    category: 'CHALLENGE',
    rarity: 'EPIC',
  },
  {
    id: 'hard_first_try',
    name: 'Hard Hitter',
    description: 'Answer a HARD question correctly on first attempt',
    icon: '🎯',
    category: 'CHALLENGE',
    rarity: 'COMMON',
  },

  // DAILY
  {
    id: 'daily_first',
    name: 'Daily Player',
    description: 'Complete your first daily challenge',
    icon: '📅',
    category: 'DAILY',
    rarity: 'COMMON',
  },
  {
    id: 'daily_streak_7',
    name: 'Daily Devotee',
    description: 'Complete 7 daily challenges in a row',
    icon: '🗓️',
    category: 'DAILY',
    rarity: 'RARE',
  },
  {
    id: 'daily_streak_14',
    name: 'Fortnight Faithful',
    description: 'Complete 14 daily challenges in a row',
    icon: '📆',
    category: 'DAILY',
    rarity: 'EPIC',
  },
  {
    id: 'daily_streak_30',
    name: 'Monthly Master',
    description: 'Complete 30 daily challenges in a row',
    icon: '🏛️',
    category: 'DAILY',
    rarity: 'LEGENDARY',
  },

  // MILESTONE
  {
    id: 'points_1000',
    name: 'Rising Scholar',
    description: 'Earn 1,000 total points across all games',
    icon: '📖',
    category: 'MILESTONE',
    rarity: 'COMMON',
  },
  {
    id: 'points_10000',
    name: 'History Buff',
    description: 'Earn 10,000 total points across all games',
    icon: '📚',
    category: 'MILESTONE',
    rarity: 'RARE',
  },
  {
    id: 'points_50000',
    name: 'Grand Historian',
    description: 'Earn 50,000 total points across all games',
    icon: '🎓',
    category: 'MILESTONE',
    rarity: 'LEGENDARY',
  },
];
